<sh-form-group
    [invalid]="false"
    [required]="false"
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [currentActionItems]="currentActionItems"
    [describeLabelId]="describeLabelId"
    [errorMsg]="errorMsg"
    [id]="controlId"
    [formGroupStyling]="formGroupStyling"
>
    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>
    <ng-container *ngIf="canBeIndeterminate; then complex; else simple"> </ng-container>

    <ng-template #complex>
        <sh-form-edtf-complex-base
            [formControl]="control"
            [id]="controlId"
            [required]="isControlRequired$ | async"
            [invalid]="isControlInvalid$ | async"
            [indeterminateMsg]="indeterminateMsg"
            [requiredFieldMsg]="errorMsg"
            [typePlaceholderMsg]="typePlaceholderMsg"
            [typeLabel]="typeLabel"
            [valueLabel]="valueLabel"
            [formatExamplePrefix]="formatExamplePrefix"
            [unrecognizedFormatMsg]="unrecognizedFormatMsg"
            [invalidFormatMsg]="invalidFormatMsg"
            [i18n]="i18n"
            class="sh-form-group__input"
            [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
        >
        </sh-form-edtf-complex-base>
    </ng-template>
    <ng-template #simple>
        <sh-form-edtf-base
            [formControl]="control"
            [id]="controlId"
            [required]="isControlRequired$ | async"
            [invalid]="isControlInvalid$ | async"
            [indeterminateMsg]="indeterminateMsg"
            [requiredFieldMsg]="errorMsg"
            [typePlaceholderMsg]="typePlaceholderMsg"
            [typeLabel]="typeLabel"
            [valueLabel]="valueLabel"
            [formatExamplePrefix]="formatExamplePrefix"
            [unrecognizedFormatMsg]="unrecognizedFormatMsg"
            [invalidFormatMsg]="invalidFormatMsg"
            [i18n]="i18n"
            class="sh-form-group__input"
            [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
        >
        </sh-form-edtf-base>
    </ng-template>
</sh-form-group>
